import { FC, MouseEventHandler, MouseEvent } from 'react'
import { toast } from 'react-toastify'
import { type SocialLink } from '../server/utils/getArticlesData'

import CustomLink from './CustomLink'

interface Props {
  items: SocialLink[] | undefined
  onClick: MouseEventHandler<HTMLAnchorElement>
}

const DropdownShare: FC<Props> = ({ items = [], onClick }) => {
  const copyLink = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    if ('clipboard' in navigator) {
      navigator.clipboard
        .writeText(e.currentTarget.href)
        .then(() => {
          toast.success('Ссылка успешно скопирована в буфер обмена')
        })
        .catch(() => {
          toast.error('Произошла ошибка копирования в буфер обмена')
        })
        .finally(() => {
          onClick(e)
        })
    }
  }

  return (
    <ul className="dropdown-share">
      {items.map((item, index) => (
        <li key={index}>
          <CustomLink {...item} type="social" onClick={onClick} />
        </li>
      ))}
      <li>
        <CustomLink
          label="Скопировать ссылку"
          href={location.href}
          icon="link"
          type="social"
          onClick={copyLink}
        />
      </li>
    </ul>
  )
}

export default DropdownShare
